import * as h2Api from '../h2Api'

export const LOAD_MY_STUFF = 'LOAD_MY_STUFF'

export const loadMyStuffData = filterParams => dispatch => {
  return dispatch(
    h2Api.post('/user/mystuff', filterParams || {})({ type: LOAD_MY_STUFF })
  )
}
